import React from 'react'
import Modal from "react-modal";
import { Icon } from "@iconify/react";

const PaymentDetailsModal = ({ paymentDeatilsByPrId, paymentDeatilsSrno, closeModal, isitemDetailsModalVisible, isSubmitted, title }) => {



    const calculateCellValue2 = (dateValue) => {
        if (!dateValue) return "";
        const d = new Date(dateValue);
        const day = String(d.getDate()).padStart(2, "0");
        const month = String(d.getMonth() + 1).padStart(2, "0");
        const year = d.getFullYear();
        return `${day}-${month}-${year}`;
    };
    return (
        <>
            <Modal
                ariaHideApp={false}
                isOpen={isitemDetailsModalVisible}
                className="react-modal custom-modal-xlarge"
                onRequestClose={closeModal}
                shouldCloseOnOverlayClick={false}
                contentLabel="Payment Modal"
            >
                <div>
                    <form
                        // onSubmit={}
                        style={isSubmitted ? { pointerEvents: "none", opacity: 0.4 } : {}}
                    >
                        <div className="modal-header">
                            <h6 className="modal-title">
                                {title} {paymentDeatilsSrno}
                            </h6>
                        </div>
                        <div className="modal-body">
                            <div class="sub-title-color" style={{ marginBottom: '0' }}>From </div>
                            <div className='card shadow-none' style={{ backgroundColor: '#f3f3f3', border: '1px solid #d1d1d1' }}>
                                <div className='card-body' style={{ padding: '0.8rem' }}>
                                    <table className='request-details'>
                                        <tr>
                                            <td><Icon icon="mdi:company" className='iconify-style' /></td>
                                            <td>
                                                <div class="fieldlable">{(paymentDeatilsByPrId?.paymentOption) ? "Company Name" : "MSME Name"}</div>
                                                <div class="fieldvalue">{(paymentDeatilsByPrId?.paymentOption) ? paymentDeatilsByPrId?.fromCompanyName : ""}</div>
                                            </td>
                                        </tr>
                                    </table>
                                    {paymentDeatilsByPrId?.paymentOption &&
                                        <table width="100%" className='custom-table table'>
                                            <thead>
                                                <tr>
                                                    <th scope="col">Bank</th>
                                                    <th scope="col">Branch</th>
                                                    <th scope="col">Acount Holder Name</th>
                                                    <th scope="col">Account Number</th>
                                                    <th scope="col">IFSC Code</th>
                                                    {/* <th scope="col">From User</th> */}

                                                </tr>
                                            </thead>
                                            <tbody>
                                                <tr>
                                                    <td>{paymentDeatilsByPrId?.fromBank}</td>
                                                    <td>{paymentDeatilsByPrId?.fromBankBranch}</td>
                                                    <td>{paymentDeatilsByPrId?.fromAccHolderName}</td>
                                                    <td>{paymentDeatilsByPrId?.fromAccountNo}</td>
                                                    <td>{paymentDeatilsByPrId?.fromBranchIFSCCode}</td>
                                                    {/* <td>{paymentDeatilsByPrId?.fromUser}</td> */}
                                                </tr>
                                            </tbody>

                                        </table>}

                                    {paymentDeatilsByPrId?.paymentOption === false &&
                                        <table width="100%" className='custom-table table'>
                                            <thead>
                                                <tr>
                                                    <th scope="col">Name</th>

                                                    {/* <th scope="col">From User</th> */}

                                                </tr>
                                            </thead>
                                            <tbody>
                                                <tr>
                                                    <td>{paymentDeatilsByPrId?.msmeName || ""}</td>

                                                    {/* <td>{paymentDeatilsByPrId?.fromUser}</td> */}
                                                </tr>
                                            </tbody>
                                        </table>}

                                </div>
                            </div>
                            <div class="sub-title-color" style={{ marginBottom: '0' }}>To </div>
                            <div className='card shadow-none' style={{ backgroundColor: '#f3f3f3', border: '1px solid #d1d1d1' }}>
                                <div className='card-body' style={{ padding: '0.8rem' }}>
                                    <table className='request-details'>
                                        <tr>
                                            <td><Icon icon="mingcute:user-3-line" className='iconify-style' /></td>
                                            <td>
                                                <div class="fieldlable">Vendor Name</div>
                                                <div class="fieldvalue">{paymentDeatilsByPrId?.vendorName}</div>
                                            </td>
                                        </tr>
                                    </table>
                                    <table width="100%" className='custom-table table'>
                                        <thead>
                                            <tr>
                                                <th scope="col">Bank</th>
                                                <th scope="col">Branch</th>
                                                <th scope="col">Acount Holder Name</th>
                                                <th scope="col">Account Number</th>
                                                <th scope="col">IFSC Code</th>
                                                <th scope="col">Vendor Code</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            <tr>
                                                <td>{paymentDeatilsByPrId?.vendorBank}</td>
                                                <td>{paymentDeatilsByPrId?.vendorBankBranch}</td>
                                                <td>{paymentDeatilsByPrId?.vendorAccHolderName}</td>
                                                <td>{paymentDeatilsByPrId?.vendorAccNo}</td>
                                                <td>{paymentDeatilsByPrId?.vendorIFSCCode}</td>
                                                <td>{paymentDeatilsByPrId?.vendorCode}</td>

                                            </tr>
                                        </tbody>
                                    </table>
                                </div>
                            </div>
                            <div class="sub-title-color" style={{ marginBottom: '0' }}>Payment Details</div>
                            <div className='card shadow-none' style={{ backgroundColor: '#f3f3f3', border: '1px solid #d1d1d1' }}>
                                <div className='card-body' style={{ padding: '0.8rem' }}>
                                    <div className='row'>
                                        {/* <div className='col-3'>
                                                  <table className='request-details'>
                                                      <tr>
                                                          <td><Icon icon="tabler:currency-rupee" className='iconify-style' /></td>
                                                          <td>
                                                              <div class="fieldlable">Payment Amount</div>
                                                              <div class="fieldvalue">{}</div>
                                                          </td>
                                                      </tr>
                                                  </table>
                                              </div> */}
                                        <div className='col-3'>
                                            <table className='request-details'>
                                                <tr>
                                                    <td><Icon icon="lets-icons:date-range" className='iconify-style' /></td>
                                                    <td>
                                                        <div class="fieldlable">Paid On</div>
                                                        <div class="fieldvalue">{calculateCellValue2(paymentDeatilsByPrId?.paidOn)}</div>
                                                    </td>
                                                </tr>
                                            </table>
                                        </div>
                                        <div className='col-3'>
                                            <table className='request-details'>
                                                <tr>
                                                    <td><Icon icon="stash:data-numbers-solid" className='iconify-style' /></td>
                                                    <td>
                                                        <div class="fieldlable">Transaction Number</div>
                                                        <div class="fieldvalue">{paymentDeatilsByPrId?.transactionNo}</div>
                                                    </td>
                                                </tr>
                                            </table>
                                        </div>
                                        <div className='col-3'>
                                            <table className='request-details'>
                                                <tr>
                                                    <td><Icon icon="streamline-ultimate:cash-payment-bill" className='iconify-style' /></td>
                                                    <td>
                                                        <div class="fieldlable">Payment Mode</div>
                                                        <div class="fieldvalue">{paymentDeatilsByPrId?.paymentModeName || ""}</div>
                                                    </td>
                                                </tr>
                                            </table>
                                        </div>

                                        <div className='col-3'>
                                            <table className='request-details'>
                                                <tr>
                                                    <td><Icon icon="mingcute:user-3-line" className='iconify-style' /></td>
                                                    <td>
                                                        <div class="fieldlable">Paid By</div>
                                                        <div class="fieldvalue">{paymentDeatilsByPrId?.fromUser}</div>
                                                    </td>
                                                </tr>
                                            </table>
                                        </div>
                                    </div>
                                    <div className='row'>

                                        {console.table(paymentDeatilsByPrId)}

                                        {(paymentDeatilsByPrId?.paymentModeId == 2 || paymentDeatilsByPrId?.paymentModeId == 3) &&
                                            <><div className='col-3'>
                                                <table className='request-details'>
                                                    <tr>
                                                        <td><Icon icon="mingcute:user-3-line" className='iconify-style' /></td>
                                                        <td>
                                                            <div class="fieldlable">Cheque Number</div>
                                                            <div class="fieldvalue">{paymentDeatilsByPrId?.chequeNo || ""}</div>
                                                        </td>
                                                    </tr>
                                                </table>
                                            </div>

                                                <div className='col-3'>
                                                    <table className='request-details'>
                                                        <tr>
                                                            <td><Icon icon="mingcute:user-3-line" className='iconify-style' /></td>
                                                            <td>
                                                                <div class="fieldlable">Cheque Date</div>
                                                                <div class="fieldvalue">{paymentDeatilsByPrId?.chequeDate || ""}</div>
                                                            </td>
                                                        </tr>
                                                    </table>
                                                </div>


                                            </>
                                        }

                                        <div className='col-3'>
                                            <table className='request-details'>
                                                <tr>
                                                    <td><Icon icon="stash:data-numbers-solid" className='iconify-style' /></td>
                                                    <td>
                                                        <div class="fieldlable">Advance Request Id</div>
                                                        <div class="fieldvalue">{paymentDeatilsByPrId?.advPaymentRequestId || ""}</div>
                                                    </td>
                                                </tr>
                                            </table>
                                        </div>

                                        <div className='col-3'>
                                            <table className='request-details'>
                                                <tr>
                                                    <td><Icon icon="gg:details-less" className='iconify-style' /></td>
                                                    <td>
                                                        <div class="fieldlable">Narration</div>
                                                        <div class="fieldvalue">{paymentDeatilsByPrId?.narration}</div>
                                                    </td>
                                                </tr>
                                            </table>
                                        </div>
                                    </div>

                                </div>
                            </div>
                        </div>
                        <div className="modal-footer">
                            <button
                                type="button"
                                className="btn btn-outline-primary btn-sm"
                                onClick={closeModal}
                                title="Close"
                            >
                                <i className="fas fa-times"></i> Close
                            </button>


                        </div>
                    </form>
                </div>
            </Modal>

        </>
    )
}

export default PaymentDetailsModal